import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import Action from 'actions';
import Const from 'constants';

class PlayerLineGroup extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {value: null};
    }

    onChange(propName, value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(propName, value) {
        const player = this.getPlayer();

        const correctValue = NumberHelper.prepareInt(value, 0)
            .limitByRange(
                Const.NHL_LINE_GROUP_MIN,
                Const.NHL_LINE_GROUP_MAX,
                Const.NHL_LINE_GROUP_MIN,
                Const.NHL_LINE_GROUP_MAX,
            )
            .get();

        this.onChange(propName, correctValue);

        this.isValueBeingChanged = false;

        this.props.dispatch(
            Action.set('PlayersLineGroup', [
                {
                    playerId: player.getId(),
                    [propName]: correctValue,
                },
            ]),
        );
    }

    getPlayer() {
        const {players, playerId} = this.props;
        return players.getPlayer(playerId);
    }

    getValue(player) {
        const {propName, mode = Const.OVERALL_MODE} = this.props;
        return this.isValueBeingChanged ? this.state.value : player.getPropValueOfMode(propName, mode);
    }

    render() {
        const player = this.getPlayer();

        if (!player) {
            return null;
        }

        const {propName, className = '', showOnlyValue = false} = this.props;
        const value = this.getValue(player);

        if (showOnlyValue) {
            return <span>{value}</span>;
        }

        return (
            <input
                className={className}
                value={`${value}`}
                onChange={(e) => ::this.onChange(propName, e.target.value)}
                onBlur={(e) => ::this.onBlur(propName, e.target.value)}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {players} = state.playersData;
    return {
        players,
    };
}

export default connect(mapStatesToProps)(PlayerLineGroup);
